import { Component, ViewChild } from '@angular/core';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import {
    stack,
    build,
} from '../../../../../common/classes/request-builder';
import { environment } from '../../../../../../environments/environment';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { AnalisisModel } from '../../../../../models/analisis/analisis.model';
import { AnalisisApiService } from '../../../../../service/api/analisis-api.service';
import { HttpClient } from '@angular/common/http';

import type { OnInit } from '@angular/core';
import { SiexApiService } from 'src/app/service/api/siex-api.service';
import { AnalisisEnvironmentDefinition } from '../environment-variables';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { AnalisisFormDefinition } from './fields/formfields';
import { Subject } from 'rxjs';
import { EventPhase, FormPhase, FormRequestTypes } from 'src/app/common/components/reactive-form-builder/form-request';

@Component({
    selector: 'app-analisis-form',
    standalone: false,
    templateUrl: './analisis-form.component.html',
    styleUrls: ['./analisis-form.component.scss'],
})
export class AnalisisFormComponent extends BaseForm<AnalisisModel> implements OnInit {
    @ViewChild(ReactiveFormBuilderComponent) formBuilder!: ReactiveFormBuilderComponent<AnalisisModel>;
    public dropdownsFinalized = false;

    /** Reactive form definition bound to the template */
    public form!: AnalisisFormDefinition;
    
    /** Form request engine (phase-based hooks) */
    public formRequest = new ReactiveFormBuilderComponent(this.http);
    
    /** Emits when dropdowns are ready to be reloaded */
    public readonly dropdownLoadTrigger = new Subject<void>();
    
    public readonly FormRequestTypes = FormRequestTypes;

    public env: AnalisisEnvironmentDefinition = new AnalisisEnvironmentDefinition();
    public enableFormChanges = true;

    public override model = {} as AnalisisModel;
    public type: FormRequestTypes = this.getType();
    public id_finca = '';

    // public analisisProximo: any;
    public programarSiguiente = false;

    public analisisImg: string | ArrayBuffer | null | undefined = '';

    public showExtraFields = false;
  
    public tipoSuperficieParcelas: string = environment.features.hasSuperficieCultivada
        ? 'S.\xa0C.'
        : 'S.\xa0Sigpac';
    public oldSector = 0;
  

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService,
        public clientesApi: ClientesApiService,
        public formApi: FormCommonApiService,
        public override dashboard: DashboardService,
        public siexApi: SiexApiService,
        public analisisApi: AnalisisApiService,
        public http: HttpClient
    ) {
        super(
            route,
            router,
            dashboard,
            analisisApi.analisis.PUT,
            analisisApi.analisis.POST,
            'analisis',
            'Editar Recordatorio de Análisis',
            'Crear Recordatorio de Análisis'
        );
    }

    ngOnInit() {
        this.dropdownsFinalized = false;
        this.form = new AnalisisFormDefinition(
            this.getType(),
            this.getModel() as unknown as Record<string,string>,
            null
        );
        this.initFormData();
        setTimeout(() => {
            this.expandFormRequest();
        }, 9000);
    

        this.formRequest.executePhase(FormPhase.LOAD);        
        this.softInit(this.getType());
    }


    public formChanges(formModel: any, _tag: string) {
        this.form.model = formModel;
    }


    changeSectores() {
        const builds = [];
        if ( this.form.env.showAnalisisSectorParcelas ) {
            builds.push(
                build(this.fincasApi.sectoresGET, this.form.lists.sectores, 'nombre', true),
                build(this.fincasApi.parcelasGET, this.form.lists.lista_parcelas, 'nombre', true),
            );

            stack(builds).then(() => {
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }
    }

    private expandFormRequest() {
        const builds = [
            build(this.clientesApi.clientesGET, this.form.lists.clientes, 'nombre'),
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true)
        ];

        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.BEFORE, (resolve) => {
            stack(builds).then(() => {          
                resolve(true);
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        });
    }

    private initFormData() {
        const builds = [
            build(this.clientesApi.clientesGET, this.form.lists.clientes, 'nombre', true),
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true),
            build(this.siexApi.comunidadesRegantesGET, this.form.lists.comunidadesRegantes, 'nombre'),
        ];

        if (this.form.env.showAnalisisParcelas) {
            builds.push(
                build(this.fincasApi.parcelasGET, this.form.lists.parcelas, 'nombre', true)
            );
        }

        stack(builds).then(() => {
            this.changeSectores();            
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();      
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }
}